module.exports = __webpack_public_path__ + "img/add_3.d518aedb.png";